//#region src/dom/locale/merge-locale-overlays.ts
/**
* Loads overlay layers for each resolved locale key, least-specific first, then merges most-specific-last (same
* semantics as the core i18n registry).
*/
async function mergeLocaleOverlays(locale, load, findKeys) {
	const chain = findKeys(locale);
	const layers = await Promise.all(chain.map((tag) => load(tag)));
	const loadedTags = [];
	const merged = {};
	for (let i = 0; i < chain.length; i++) {
		const layer = layers[i];
		if (layer && Object.keys(layer).length > 0) loadedTags.push(chain[i]);
	}
	for (let i = chain.length - 1; i >= 0; i--) {
		const layer = layers[i];
		if (layer) Object.assign(merged, layer);
	}
	return {
		merged,
		loadedTags
	};
}
//#endregion
export { mergeLocaleOverlays };

//# sourceMappingURL=merge-locale-overlays.js.map